import { render, staticRenderFns } from "./RelacaoBolsistasFiltro.vue?vue&type=template&id=77c13ef4"
import script from "./RelacaoBolsistasFiltro.vue?vue&type=script&lang=js"
export * from "./RelacaoBolsistasFiltro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports